import { LOGIN_OTP_STATE } from '../../context/LoginRegistrationUserLoginStateContext'

interface MakeLoginRegistrationOneTimePasswordNavigationHandlersParameters {
  clearGuestEmail: () => void
  onBackToPassword?: () => void
  onChangeEmail?: () => void
  setLoginOtpState: (loginOtpState: LOGIN_OTP_STATE) => void
  setUsername: (username: string) => void
}

interface LoginRegistrationOneTimePasswordNavigationHandlers {
  handleBackToPassword: () => void
  handleChangeEmail: () => void
  handleRequestNewCode: () => void
}

export const makeLoginRegistrationOneTimePasswordNavigationHandlers = ({
  clearGuestEmail,
  onBackToPassword,
  onChangeEmail,
  setLoginOtpState,
  setUsername,
}: MakeLoginRegistrationOneTimePasswordNavigationHandlersParameters): LoginRegistrationOneTimePasswordNavigationHandlers => {
  const handleBackToPassword = (): void => {
    if (onBackToPassword) {
      onBackToPassword()

      return
    }

    setLoginOtpState(LOGIN_OTP_STATE.LOGIN_REGISTER)
  }

  const handleChangeEmail = (): void => {
    if (onChangeEmail) {
      onChangeEmail()

      return
    }

    clearGuestEmail()
    setUsername('')
    setLoginOtpState(LOGIN_OTP_STATE.OTP_REQUEST_NEW_CODE)
  }

  const handleRequestNewCode = (): void => {
    setLoginOtpState(LOGIN_OTP_STATE.OTP_REQUEST_NEW_CODE)
  }

  return {
    handleBackToPassword,
    handleChangeEmail,
    handleRequestNewCode,
  }
}
